import { Link } from "react-router-dom";
import NavBar from "@/components/NavBar";
import SEOHead from "@/components/SEOHead";
import BreadcrumbSEO from "@/components/BreadcrumbSEO";
import Footer from "@/components/Footer";
import { Mail } from "lucide-react";

const Contact = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Contacto | CompresorJPEG"
        description="Contáctanos para preguntas, sugerencias o soporte técnico sobre CompresorJPEG, tu herramienta gratuita de compresión de imágenes online."
        keywords="contacto compresorjpeg, soporte compresor imagenes, ayuda compresion fotos"
        canonical="https://compresorjpeg.com/contact"
      />
      <NavBar />

      <div className="container mx-auto px-4">
        <BreadcrumbSEO
          items={[
            { label: "Inicio", href: "/" },
            { label: "Contacto" },
          ]}
        />
      </div>

      <main className="container mx-auto px-4 py-12 max-w-2xl">
        <h1 className="text-3xl font-bold text-foreground mb-4">Contacto</h1>

        <p className="text-muted-foreground mb-4 leading-relaxed">
          Si tienes alguna duda, sugerencia o encuentras algún problema en la herramienta, puedes escribirme directamente.
        </p>

        <p className="text-muted-foreground mb-8 leading-relaxed">
          También puedes contactarme si necesitas ayuda relacionada con la compresión de imágenes o la optimización web.
        </p>

        <div className="flex items-center gap-4 p-6 rounded-lg bg-muted/50 border border-border mb-6">
          <Mail className="h-6 w-6 text-primary shrink-0" />
          <div>
            <p className="text-sm text-muted-foreground mb-1">Correo electrónico</p>
            <a
              href="mailto:info@compresorjpeg.com"
              className="text-lg font-medium text-primary hover:underline"
            >
              info@compresorjpeg.com
            </a>
          </div>
        </div>

        <p className="text-sm text-muted-foreground mb-2">
          Este sitio es mantenido de forma activa por Javier Treviño, por lo que cualquier mensaje será atendido.
        </p>
        <p className="text-sm text-muted-foreground mb-12">
          Responderé lo antes posible.
        </p>

        <div className="pt-6 border-t border-border text-sm text-muted-foreground">
          <Link to="/" className="text-primary hover:underline">← Volver al compresor</Link>
          {" · "}
          <Link to="/about" className="text-primary hover:underline">Sobre nosotros</Link>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Contact;
